export enum LicenseTypes {
    Trial = "Trial",
    HostingTrial = "HostingTrial",
    TrialExtendable = "TrialExtendable",
    Regular = "Regular",
    InHouseSubscription = "InHouseSubscription",
}

export enum LicensePlans {
    /** Legacy Team */
    MixedPro = "MixedPro",
    /** Legacy Enterprise */
    MixedEnterprise = "MixedEnterprise",
    /** PSA Lite */
    NonPSPro = "NonPSPro",
    /** Enterprise */
    NonPSEnterprise = "NonPSEnterprise",
    /** Birdview PSA Team */
    PSPro = "PSPro",
    /** Birdview PSA Enterprise */
    PSEnterprise = "PSEnterprise",
    /** Birdview Projects Management Lite */
    PMLite = "ProjectsManagementLite",
    /** Birdview Projects Management Team */
    PMTeam = "ProjectsManagementTeam",
    /** Birdview Projects Management Enterprise */
    PMEnterprise = "ProjectsManagementEnterprise",
    /** Birdview Resource Management Team */
    RMTeam = "ResourceManagementTeam",
    /** Birdview Resource Management Enterprise */
    RMEnterprise = "ResourceManagementEnterprise",
}

/*
 * License plans like in Account Control (Customer Portal)
 * @see {@link https://github.com/LogicSoftware/AccountsControl/blob/master/epcustomerportalclient/src/constants/enums.ts#L1 }
 */
export enum LicensePlansLikeInAccountControls {
    LegacyTeam = "Legacy Team",
    LegacyEnterprise = "Legacy Enterprise",
    /** Birdview PSA Lite */
    Team = "Team",
    Enterprise = "Enterprise",
    /** Birdview PSA Lite (NonPSPro + IsBirdviewBrand is true) */
    PSALite = "PSA Lite",
    /** Birdview PSA Team */
    PSATeam = "PSA Team",
    /** Birdview PSA Enterprise */
    PSAEnterprise = "PSA Enterprise",
    /** Birdview Projects Management Lite */
    PMLite = "Project Management Lite",
    /** Birdview Projects Management Team */
    PMTeam = "Project Management Team",
    /** Birdview Projects Management Enterprise */
    PMEnterprise = "Project Management Enterprise",
    /** Birdview Resource Management Team */
    RMTeam = "Resource Management Team",
    /** Birdview Resource Management Enterprise */
    RMEnterprise = "Resource Management Enterprise",
}
